module.exports = __webpack_public_path__ + "img/9diamonds.44e04122.jpg";